import { Injectable } from '@angular/core';
import { PrintModel } from '../../models/route-print-model';
import { RoutePlannerSummaryData } from '../../models/route-model';
import { SummaryData } from '../../models/route-summary-model';
import { RouteDataStoreService } from 'src/app/modules/aa-core/services/data-store/data-store.service';
import { EventsService } from 'src/app/core/services/events.service';
import { PrintRoutePlanner } from 'src/app/core/events/print-events';
import { RouteSignpostsService } from '../route-signposts/route-signposts.service';

@Injectable({
  providedIn: 'root'
})
export class RoutePlannerPrintService {

  private routeSummaryData: RoutePlannerSummaryData;

  constructor( private dataStore: RouteDataStoreService,
    private routeSignpostsService: RouteSignpostsService,
    private eventsService: EventsService) {
    this.routeSummaryData = this.dataStore.routeDataModel.SummaryData;
  }

  get printModel(): PrintModel {
    return this.dataStore.routeDataModel.PrintModel;
  }

  get selectedSummaryData(): SummaryData {
    return this.routeSummaryData.getSelectedSummaryData();
  }

  public print(): void {
    // if (this.printModel.MapSettings.preparing) { return; }

    // const routeSignpostList = this.routeSignpostsService.routeSignpostList.RouteSignpost;
    // let countOpenGoogleMap = 0;
    // routeSignpostList.forEach(element => {
    //   element.RouteLegs.forEach( element => {
    //     (element.showGoogleMap) ? countOpenGoogleMap++ : null;
    //   });
    // });
    // const delay = (countOpenGoogleMap * 700) + 3000;

    // this.printModel.MapSettings.preparing = true;
    // this.eventsService.dispatch(PrintRoutePlanner.UPDATE_PRINT_PREVIEW, {printable: true});

    // this.printModel.MapSettings.preparing = false;
    window.print();
  }

}
